const listNewLineTypes = [
    'paragraph',
    'linebreak',
    'listitem'
];
const decompose = (list)=>{
    const regExp = /[ ]{2,}/g;
    return list.map((item)=>{
        const prefix = listNewLineTypes.includes(item.type) ? ' ' : '';
        if (null == item ? void 0 : item.children) return prefix + decompose(item.children);
        return prefix + (item.text || '');
    }).join('').replaceAll(regExp, ' ');
};
const useLexicalText = ()=>(input)=>{
        try {
            var _lexicalObject_root;
            const lexicalObject = JSON.parse(input);
            return decompose(null == (_lexicalObject_root = lexicalObject.root) ? void 0 : _lexicalObject_root.children).trim();
        } catch (unused) {
            return '';
        }
    };
export { useLexicalText };
